import { render, staticRenderFns } from "./BusinessClassSelector.vue?vue&type=template&id=104f8f24&scoped=true&"
import script from "./BusinessClassSelector.vue?vue&type=script&lang=js&"
export * from "./BusinessClassSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f8f24",
  null
  
)

export default component.exports